import {
  PromptFormAction,
  PromptFormState,
  PromptPageAction,
  PromptPageState,
} from './PromptHelpers';

export const initialFormState: PromptFormState = {
  name: '',
  patternType: null,
  sortOrder: 0,
  prompt: '',
  role: '',
  goal: '',
  instruction: '',
  narrowing: '',
  stepsToComplete: '',
  checks: '',
  details: '',
  examples: '',
  objective: '',
  additionalGuidelines: '',
  benchmark: '',
  recursion: '',
  speaker: '',
  listener: '',
  listenerRole: '',
};

export function formReducer(state: PromptFormState, action: PromptFormAction): PromptFormState {
  switch (action.type) {
    case 'SET_FIELD':
      return { ...state, [action.field]: action.value };
    case 'SET_PATTERN_TYPE':
      return { ...state, patternType: action.value };
    case 'SET_SORT_ORDER':
      return { ...state, sortOrder: action.value };
    case 'LOAD_PROMPT':
      return { ...state, ...action.data };
    case 'RESET':
      return initialFormState;
    default:
      return state;
  }
}

export const initialPageState: PromptPageState = {
  loading: false,
  error: null,
  isNew: true,
  isDisabled: true,
  isOptimizerOpen: false,
};

export function pageReducer(state: PromptPageState, action: PromptPageAction): PromptPageState {
  switch (action.type) {
    case 'SET_LOADING':
      return { ...state, loading: action.value };
    case 'SET_ERROR':
      return { ...state, error: action.value };
    case 'SET_IS_NEW':
      return { ...state, isNew: action.value };
    case 'SET_IS_DISABLED':
      return { ...state, isDisabled: action.value };
    case 'SET_OPTIMIZER_OPEN':
      return { ...state, isOptimizerOpen: action.value };
    default:
      return state;
  }
}
